import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import swal from "sweetalert";
import { customMultiValue, customOption } from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { ApiFinance } from "../config/finance/ApiFinance";
import { GetLanguageString } from "../helper/Components";
import FundFilter from "../helper/SearchFilter/FundFilter";
import SelectUnit from "../shared/SelectUnit";

const ManageIncomeFilters = ({ values, setValues, handleSubUnits }) => {
  const { t } = useTranslation();
  const unitTypeName = encryptStorage.getItem("unitTypeName");

  const [loading, setLoading] = useState({
    source: false,
  });
  const [financeCategories, setFinanceCategories] = useState([]);

  const handleFinanceCategoryChange = (val) => {
    setValues((prev) => ({
      ...prev,
      selectedFinanceCategories: val || [],
    }));
  };

  useEffect(() => {
    setLoading((prev) => ({ ...prev, source: true }));

    ApiFinance()
      .GetFinanceAccountCategoriesListByType("income")
      .then((res) => {
        setFinanceCategories(res.data);
      })
      .catch((err) => {
        console.error(err);
        swal({
          title: err,
          text: err.response?.data,
          icon: "error",
          buttons: "OK",
        });
      })
      .finally(() => setLoading((prev) => ({ ...prev, source: false })));
  }, [setValues, unitTypeName]);

  return (
    <>
      <Row>
        <SelectUnit
          values={values}
          setValues={setValues}
          unitId={values.unit.value}
        />
      </Row>
      <Row>
        <Col md="2">
          <FormGroup check>
            <Label check for="subUnit">
              <Input
                id="subUnit"
                type="checkbox"
                name="isSubUnits"
                checked={values.isSubUnits}
                value={!values.isSubUnits}
                onChange={handleSubUnits}
              />
              {<GetLanguageString props="member_search_member_sub_unit" />}
            </Label>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="3">
          <FormGroup>
            <Label className="col-form-label">
              {<GetLanguageString props="funds_source" />}
            </Label>
            <Select
              components={{
                Option: customOption,
                MultiValue: customMultiValue,
              }}
              options={financeCategories}
              name="selectedFinanceCategories"
              value={values.selectedFinanceCategories}
              className="basic-multi-select no-drag"
              classNamePrefix="select"
              isLoading={loading.source}
              isDisabled={financeCategories.length === 0}
              isMulti
              onChange={handleFinanceCategoryChange}
              placeholder={t("member_select")}
            />
          </FormGroup>
        </Col>
      </Row>
      {/* Bank Account */}
      {/*   <Row><Col md="4">
              <FormGroup>
                <Label className="col-form-label">
                  <GetLanguageString props="fund_bank_account" />
                </Label>
                <Select
                  options={bankAccountList}
                  value={selectedBankAccount}
                  placeholder="Select bank account"
                  className="basic-single no-drag"
                  classNamePrefix="select"
                  onChange={(option) => {
                    setSelectedBankAccount(option);
                    setAccountType(resolveAccountType(option));
                    setValues((prev) => ({
                      ...prev,
                      bankAccountId: option ? option.value : 0,
                    }));
                  }}
                />
              </FormGroup>
            </Col> 
          </Row>*/}
      <Row>
        <FundFilter
          values={values}
          setValues={setValues}
          showFullDate={false}
        />
      </Row>
    </>
  );
};

export default ManageIncomeFilters;
